$(document).ready(function() {

  let hasCatBreedsArray = $('body').hasClass('template-product') && $('product-info').hasClass('has-cat-breeds');
  let hasDogBreedsArray = $('body').hasClass('template-product') && $('product-info').hasClass('has-dog-breeds');

  function initializeBreedSelect(container) {
    const breedSelect = $('<select class="breed-select"></select>');

    const containerTitle = $(container).find('.g-selector-label').text().toLowerCase();

    let allBreeds = [];

    if (containerTitle.includes("dog") && dogBreeds.length > 0) {
      allBreeds = dogBreeds;
    } else if (containerTitle.includes("cat") && catBreeds.length > 0) {
      allBreeds = catBreeds;
    }

    if (allBreeds.length === 0) return;

    allBreeds.forEach((breed, index) => {
      breedSelect.append(`<option value="${index}">${breed}</option>`);
    });

    const targetDiv = $(container).find('div:nth-of-type(2)');

    if (targetDiv.length > 0) {
      targetDiv.append(breedSelect);
    } else {
      return;
    }

    const allButtons = $(container).find('button');
    allButtons.hide();

    breedSelect.change(function() {
      const selectedIndex = $(this).val();

      allButtons.hide();

      if (allButtons.eq(selectedIndex).length > 0) {
        allButtons.eq(selectedIndex).find('img').click();
      }
    });
  }

  function resetAndReinitialize() {
    $('.breed-select').remove();
    $('.template-product .g-selector-container.g-selector-collection').each(function() {
      const container = $(this);
      container.removeClass('initialized');  // Remove the initialized class to reset it
      initializeBreedSelect(container);
      container.addClass('initialized');
    });
  }

  if(hasCatBreedsArray || hasDogBreedsArray) {
    setTimeout(() => {
      $('.template-product .g-selector-container.g-selector-collection').each(function() {
        const container = $(this);
        if (!container.hasClass('initialized')) {
          initializeBreedSelect(container);
          container.addClass('initialized');
        }
      });

      $('.g-selector-buttons button, .g-selector-buttons .g-selector-button').click(function() {
        setTimeout(() => {
          resetAndReinitialize();
        }, 1200);  // Call the function to reset and reinitialize
      });
    }, 4000);
  }
  
});
